import { Component, Input, OnChanges, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModalComponent } from '../base-modal.component';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss'
})
export class ConfirmModalComponent extends BaseModalComponent implements OnChanges {
  @ViewChild('content') content: any;
  @Input() confirmText: string = 'delete';
  @Input() denyText: string = 'cancelDelete';
  @Input() isOpen: boolean = false;
  @Input() title: string = '';
  @Input() titleArgs: any = {};
  @Input() bodyText?: string;

  override ngOnChanges(changes: SimpleChanges): void {
    const isOpenChange: SimpleChange = changes['isOpen'];

    if (isOpenChange && isOpenChange.currentValue === true && isOpenChange.previousValue === false) {
      this.open(this.content);
    }
  }

  onConfirm(): void {
    this.confirm.emit();
    this.close();
  }
}
